import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styles: `
    img.cursor-pointer {
      height: 40px;
      width: auto;
      object-fit: contain;
    }
    .animation-open-menu {
       height: 370px;
    animation: frame-animation-open-menu 0.5s ease;
}

@keyframes frame-animation-open-menu {
  0% {
    height: 0px;
  }

  100% {
    height: 370px;
  }
}

  .animation-close-menu {
       height: 370px;
    animation: frame-animation-close-menu 0.6s ease;
}

@keyframes frame-animation-close-menu {
  0% {
    height: 370px !important;
  }

  100% {
    height: 0px;
  }
}
  `,
  standalone: false
})
export class MenuComponent implements OnInit {
  constructor(private router: Router , private translocoService: TranslocoService) { }
  static indexActive = -1
  showMenu = false
  closeMenu = false
  showBandiMenu: boolean = false;
  isBandiMobileOpen: boolean = false;
  showPianiMenu: boolean = false;
  isPianiMobileOpen: boolean = false;

  showLogout = window.localStorage.getItem('token') ? true : false
  refI = MenuComponent

  ngOnInit(): void {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      if (!this.closeMenu) {
        this.showMenu = false;
      }
      this.isBandiMobileOpen = false;
      this.showBandiMenu = false;
      this.isPianiMobileOpen = false;
      this.showPianiMenu = false;
    });


    switch (window.location.pathname.split('/')[1]) {
      case '':
        MenuComponent.indexActive = 0
        break;
      case 'bando':
        MenuComponent.indexActive = 0
        break;
      // case 'cerca-bando':
      //   MenuComponent.indexActive = 0
      //   break;
      case 'chi-siamo':
        MenuComponent.indexActive = 1
        break;
      case 'servizi':
        MenuComponent.indexActive = 2
        break;
      case 'news':
        MenuComponent.indexActive = 3
        break;
      case 'dicono-di-noi':
        MenuComponent.indexActive = 4
        break;
      case 'unisciti-al-team':
        MenuComponent.indexActive = 5
        break;
      case 'contatti':
        MenuComponent.indexActive = 6
        break;
      case 'piani':
        MenuComponent.indexActive = 8
        break;
      case 'cerca-bando':
        MenuComponent.indexActive = 9
        break;
      case 'login':
        MenuComponent.indexActive = 7
        break;
      case 'registrazione':
        MenuComponent.indexActive = 7
        break;
      case 'completa-profilo':
        MenuComponent.indexActive = 7
        break;
      case 'piani-disponibili':
        MenuComponent.indexActive = 7
        break;
      default:
        MenuComponent.indexActive = -1
        break;
    }
  }

  goTo(route: string) {
    this.closeMenuMobile();
    this.router.navigate([route])
    let containerWeb = document.getElementById('container-web')
    if (containerWeb) {
      containerWeb.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }

  closeMenuMobile() {
    if (this.showMenu) {
      this.closeMenu = true;
      this.isBandiMobileOpen = false;
      this.isPianiMobileOpen = false;

      setTimeout(() => {
        this.showMenu = false;
        this.closeMenu = false;
      }, 499); // rispetta la tua animazione da 499ms
    }
  }


  activateMenu() {
    if (this.showMenu) {
      this.closeMenu = true
      this.isBandiMobileOpen = false;
      this.isPianiMobileOpen = false;

      setTimeout(() => {
        this.showMenu = false
        this.closeMenu = false
      }, 499);
    } else {
      this.showMenu = true
    }
  }

  changeIntoManager() {
    if (localStorage.getItem('token')) {
      switch (JSON.parse(localStorage.getItem('user') ?? '')?.role) {
        case 1:
          this.router.navigate(['profilo'])
          break;
        case 2:
          if (JSON.parse(localStorage.getItem('user') ?? '').planId) {
            this.router.navigate(['profilo'])
          } else {
            if (JSON.parse(localStorage.getItem('user') ?? '').completed) {
              this.router.navigate(['seleziona-piano'])
            } else {
              this.router.navigate(['completa-profilo'])
            }
          }
          break;
        case 3:
          // this.router.navigate(['seleziona-piano'])
          if (JSON.parse(localStorage.getItem('user') ?? '').planId) {
            this.router.navigate(['profilo'])
          } else {
            if (JSON.parse(localStorage.getItem('user') ?? '').completed) {
              this.router.navigate(['seleziona-piano'])
            } else {
              this.router.navigate(['completa-profilo'])
            }
          }
          break;
        case 4:
          if (JSON.parse(localStorage.getItem('user') ?? '').planId) {
            this.router.navigate(['profilo'])
          } else {
            if (JSON.parse(localStorage.getItem('user') ?? '').completed) {
              this.router.navigate(['seleziona-piano'])
            } else {
              this.router.navigate(['completa-profilo'])
            }
          }
          break;
        case 5:
          this.router.navigate(['bandi-admin'])
          break;
        case 6:
          if (JSON.parse(localStorage.getItem('user') ?? '').planId || true) {
            this.router.navigate(['profilo'])
          } else {
            if (JSON.parse(localStorage.getItem('user') ?? '').completed) {
              this.router.navigate(['seleziona-piano'])
            } else {
              this.router.navigate(['completa-profilo'])
            }
          }
          break;
        case 7:
          this.router.navigate(['profilo'])
          break;
        default:
          if (JSON.parse(localStorage.getItem('user') ?? '').planId) {
            this.router.navigate(['profilo'])
          } else {
            if (JSON.parse(localStorage.getItem('user') ?? '').completed) {
              this.router.navigate(['seleziona-piano'])
            } else {
              this.router.navigate(['completa-profilo'])
            }
          }
          break;
      }
    } else {
      this.router.navigate(['login'])
    }
  }

  logout() {
    localStorage.clear()
    window.location.replace('')
  }

  changeAccess() {
    if (window.location.pathname == '/login') {
      this.router.navigate(['registrazione'])
    } else {
      this.router.navigate(['login'])
    }
  }

  toggleAndNavigate() {
    this.showBandiMenu = !this.showBandiMenu;
    MenuComponent.indexActive = 9;
    //this.goTo('cerca-bando');
  }

  goToBlog() {
    window.location.href = 'https://blog.innovationplaza.it/';
  }

  navigateToCategory(path: string) {
    this.closeMenuMobile();
    this.showBandiMenu = false;
    this.router.navigate([path]);
  }

  togglePianiMenu() {
    this.showPianiMenu = !this.showPianiMenu;
    MenuComponent.indexActive = 8;
  }

  navigateToPiano(path: string) {
    this.closeMenuMobile();
    this.showPianiMenu = false;
    this.router.navigate([path]);
  }

goToRegister(){
  const registrationMessage = 'Registrati gratuitamente';
  this.translocoService.selectTranslateObject('routes').subscribe(() => {
    this.router.navigate(['/', 'registrazione']);
  });
}


}

